import script from "./PlanModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanModal.vue?vue&type=script&setup=true&lang=js"

import "./PlanModal.vue?vue&type=style&index=0&id=6ff46627&lang=css"

const __exports__ = script;

export default __exports__